export const COMPANY_USERS_REQUEST = 'COMPANY_USERS_REQUEST'
export const COMPANY_USERS_RESET = 'COMPANY_USERS_RESET'
export const COMPANY_USERS_SUCCESS = 'COMPANY_USERS_SUCCESS'
export const COMPANY_USERS_ERROR = 'COMPANY_USERS_ERROR'
